/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SetupAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SetupAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appConnectionValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'connection',
})
let appConnectionsValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'connections',
})
let automationsValueData = fromData.useDataValue({ viewPath,
context: 'automations',
})
let aggregateData = fromHelpers.getView(appConnectionValueData, appConnectionsValueData, automationsValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}